export const URL_API = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production' ? 'https://api.castrafacil.com.br' : 'http://localhost:3333'
export const URL_API_PANEL = URL_API + '/panel';